import {connect} from '@modifi/redux'

import {aShowShipmentTrackingDetailsDialog} from '../../../../features/shipment-tracking-details'
import ShipmentEntry from './ShipmentEntry'

const mapStateToProps = null

const mapDispatchToProps = {
  showDetails: aShowShipmentTrackingDetailsDialog,
}

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentEntry)
